import { elementVisibleInMode, type SchemaData } from '../schema/types'

/**
 * Element ids the line view lights up on the map — the line counterpart of
 * `extractRouteElementIds`, fed to the same `RouteHighlightOverlay`: every
 * connection of the line, every station record on it (their texts and
 * direction arrows follow in the overlay) and every transition joining two
 * of the line's own platforms (Euston's two Northern platforms, Camden Town).
 * The day line only: night-only elements (TASK-1136) are not lit.
 */
export function extractLineElementIds(schema: SchemaData, lineId: string): ReadonlySet<string> {
  const ids = new Set<string>()
  const stationIds = new Set<string>()
  for (const station of schema.stations) {
    if (station.line.id !== lineId || !elementVisibleInMode(station.modes, 'normal')) continue
    stationIds.add(station.id)
    ids.add(station.id)
  }
  for (const connection of schema.connections) {
    if (connection.lineId === lineId && elementVisibleInMode(connection.modes, 'normal')) {
      ids.add(connection.id)
    }
  }
  for (const transition of schema.transitions ?? []) {
    if (
      stationIds.has(transition.fromStationId) &&
      stationIds.has(transition.toStationId) &&
      elementVisibleInMode(transition.modes, 'normal')
    ) {
      ids.add(transition.id)
    }
  }
  return ids
}
